// extracted by mini-css-extract-plugin
export default {"tooltip":"xsellTooltip_tooltip","content":"xsellTooltip_content","row":"xsellTooltip_row"};